import ResetPasswordComponent from "./ResetPasswordComponent";

export default ResetPasswordComponent;
